<template>
  <div
    class="bi bi-circle icon-spinner status-icon text-info"
    style="clip-path: polygon(0 0, 100% 0, 100% 50%, 0 50%);"
  ></div>
</template>

<style lang="scss" scoped>
@import "../styles/animations";
.icon-spinner { display: inline-block; }
</style>
